import { createAction, props } from '@ngrx/store';
import { BookingListState } from './booking-list.state';

/** StateDetailsActions */
const ACTION_SET = '[BookingList] set';
const ACTION_UPDATE = '[BookingList] update';
const ACTION_RESET = '[BookingList] reset';
const ACTION_ADD = '[BookingList] add a entity';

/**
 * Clear the current store object and replace it with the new one
 */
export const setStateBookingList = createAction(ACTION_SET, props<BookingListState>());

/**
 * Change a part or the whole object in the store.
 */
export const updateStateBookingList = createAction(ACTION_UPDATE, props<Partial<BookingListState>>());

/**
 * Clear the whole state, return to the initial one
 */
export const resetStateBookingList = createAction(ACTION_RESET);
